import { UserVuetifyPreset } from 'vuetify';
export class VuetifyOptions {
    static options: Partial<UserVuetifyPreset> = {
        icons: {
            iconfont: 'fa4',
        },
        theme: {
            themes: {
                light: {
                    primary: '#0064d2', // '#1976D2',
                    secondary: '#5e50bf' , // '#424242',
                    accent: '#a0168c', // '#82B1FF',
                    error: '#d0021b', // '#FF5252',
                    info: '#b3e0fd', // '#2196F3',
                    success: '#008a00', // '#4CAF50',
                    warning: '#f05a00', // '#FFC107',
                },
            },
        },
    };
}
